import { render, staticRenderFns } from "./wxLogin.vue?vue&type=template&id=722a7e6f&scoped=true"
import script from "./wxLogin.vue?vue&type=script&lang=ts"
export * from "./wxLogin.vue?vue&type=script&lang=ts"
import style0 from "./wxLogin.vue?vue&type=style&index=0&id=722a7e6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a7e6f",
  null
  
)

export default component.exports